/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2022-07-20 10:02:38
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-10-27 18:09:12
 */
//注入按钮
import "./sysButton";
import directives from './directives/index.js'

import { DsfDataViewPage } from './page'
import * as  Ctrls from './components';
const components = {
  DsfDataViewPage,
  ...Ctrls
}
function install(Vue) {
  //注册指令
  Vue.use(directives)

  for (let key in components) {
    let it = components[key];
    let name = dsf.isFunction(it) ? (it.ctrlName||key) : it.name;
    Vue.component(name, it);
    if (!window.$components["dataview"]) {
      window.$components["dataview"] = {};
    }
    window.$components["dataview"][name] = it;
  }
}
export default install;

export { install };
